import type { ReactNode } from 'react'
import { create } from 'zustand'

export interface BreadcrumbOverride {
  segment: string
  label: string
  documentTitle?: string
}

interface HeaderNavState {
  actions: ReactNode | null
  breadcrumbOverrides: BreadcrumbOverride[]
  setActions: (actions: ReactNode | null) => void
  setBreadcrumbOverride: (segment: string, label: string, documentTitle?: string) => void
  clearBreadcrumbOverrides: () => void
}

export const useHeaderNavStore = create<HeaderNavState>()((set) => ({
  actions: null,
  breadcrumbOverrides: [],
  setActions: (actions) => {
    set({ actions })
  },
  setBreadcrumbOverride: (segment, label, documentTitle) => {
    set((state) => {
      const filtered = state.breadcrumbOverrides.filter((o) => o.segment !== segment)
      return { breadcrumbOverrides: [...filtered, { segment, label, documentTitle }] }
    })
  },
  clearBreadcrumbOverrides: () => {
    set({ breadcrumbOverrides: [] })
  }
}))
